import React, { useMemo } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Contact } from "../../interfaces/DTO/crm/contact";
import { MimshakData } from "../../interfaces/DTO/mimshakData";
import LoanMetricsCards from "./LoanMetricsCards";
import { MimshakDataUtil } from "../../services/mimshakDataUtil";
import { Product } from "../../interfaces/DTO/mislaka_xml_models";
import LoanRepaymentTable from "../PersonFinancialData/Tabels/LoanRepaymentTable";
import LoansTable from "../PersonFinancialData/Tabels/LoansTable";
import { FundDataBasic } from "../../interfaces/DTO/FundDataBasic";
import LoansCard from "../PersonFinancialData/Cards/LoansCard";
import LoanEligibilityTable from "./LoanEligibilityTable";
import SecurePillowToggle from "./SecurePillowToggle";
import SelfBankHeader from "./SelfBankHeader";

interface BenefitsMetricsProps {
  contacts: Contact[];
  mimshakData: MimshakData[];
  selectedPeriod: string | null;
  viewedType: "USER" | "FAMILY";
}

interface SelfBankPageProps extends BenefitsMetricsProps {
    name: string;
  fundData: FundDataBasic[];
}

const SelfBankPage: React.FC<SelfBankPageProps> = ({
  name,
  contacts,
  mimshakData,
  selectedPeriod,
  viewedType,
  fundData,
}) => {
  const products: Product[] = useMemo(
    () => MimshakDataUtil.extractAllProducts(mimshakData),
    [mimshakData]
  );
  const loanProducts = useMemo(() => {
    return mimshakData
      .flatMap((m) => m.data?.products || [])
      .filter((p) =>
        p.policies_or_accounts?.some((pol) => pol.loan_details && pol.loan_details.length > 0)
      );
  }, [mimshakData]);

  return (
    <>
      <SelfBankHeader
        name={name}
        contacts={contacts}
        mimshakData={mimshakData}
        fundData={fundData}
      />
    {/* <SecurePillowToggle contacts={contacts} /> */}
    <LoanEligibilityTable products={products} fundData={fundData} />
    {loanProducts.length > 0 && (
      <Box sx={{ m: 4 }}>
       <Typography variant="h6"> ההלוואות שלי </Typography>
            <LoanMetricsCards products={products} />
            <LoansTable products={products} />
           <Grid container spacing={3}>
              {loanProducts.map((product, index) => (
                  <Grid item xs={12} md={6} key={index}>
                  <LoansCard product={product} />
                  </Grid>
              ))}
              </Grid>
            <LoanRepaymentTable products={products} />
      </Box>
    )}
    </>
  );
};

export default SelfBankPage;
